import { jwtDecode } from "jwt-decode";
import { localStorageGet, getToken } from "./LocalStorageHelper";
import { getNewTokens } from "../repositories/PredsenseRepository";

export const onRefreshToken = () => {
  const token = getToken();
  const refreshToken = localStorageGet("refreshToken");
  const tokenDecoded = !!token && jwtDecode<any>(token);
  const now = Date.now();

  if (
    !!tokenDecoded &&
    now < tokenDecoded.exp * 1000 &&
    tokenDecoded.exp * 1000 - now <
      (tokenDecoded.exp - tokenDecoded.iat) * 1000 * 0.3
  ) {
    if (!!refreshToken) {
      return getNewTokens(refreshToken);
    }
  }
};
